import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { Button } from "react-aria-components";
import { EntityNames } from "../../../../../enums/EntityNames";
import { ReturnStatusSmartEnum } from "../../../../../enums/Domain/ReturnStatusSmartEnum";
import PrintReturn from "../../../print/PrintReturn";
import { formatAddressString } from "../../../../../helpers/StringHelper";


export default function SidePanelReturnsView({ data, onViewPage }: any) {
    const navigate = useNavigate()
    function viewEntity() {
        Navigation.view.navigate(navigate, EntityNames.returns, data.id, data)
    }
    return (<>
        {data &&
            <>
                {<SidePanelHeader descriptor="Return" value={`${data.reference}`} statuses={[data.status]} onClick={!onViewPage ? () => viewEntity() : undefined} />}
                <Actions data={data} />
                <SidePanelInfo
                    values={[
                        { label: "Requested by", value: data.requestedBy ?? data.createdBy },
                    ]}
                />
                <SidePanelInfo
                    values={[
                        { label: "Courier Website", value: data.courierUrl },
                        { label: "Tracking code", value: data.trackingCode },
                        { label: "Delivery Address", value: formatAddressString(data.deliveryAddress), classname: "whitespace--pre-line" },
                    ]}
                />
            </>
        }
    </>)
}

function Actions({ data }: { data: any }) {

    return (
        <div className="display--flex gap--s flex__wrap--wrap margin__top--s">
            {data.status.value === ReturnStatusSmartEnum.Draft.value && <EditButton id={data.id} />}
            {data.status.value === ReturnStatusSmartEnum.ToPack.value && <PrintReturn returnId={data.id} />}
        </div>
    )
}

function EditButton({ id }: { id: string }) {
    const navigate = useNavigate()

    return (
        <Button className={"button button--small button--primary button--with-icon"} onPress={() => { Navigation.CreateReturns.navigate(navigate, id) }}>
            <p className="button-text">Edit Return</p>
        </Button>
    )
}